import React from 'react';
import { withRouter } from 'react-router-dom';
import { scrollToTop } from '../../utils/scrollToTop.js';
class ScrollToTopOnNavigation0 extends React.Component {
    componentDidMount() {
        if (this.props.on_mount) {
            scrollToTop();
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.on_location_change && this.props.location.pathname !== prevProps.location.pathname) {
            scrollToTop();
        }
    }
    render() {
        return null;
    }
}
export const ScrollToTopOnNavigation = withRouter(ScrollToTopOnNavigation0);
//# sourceMappingURL=index.js.map